import { render, staticRenderFns } from "./ExamCheckBox.vue?vue&type=template&id=a5310866&"
import script from "./ExamCheckBox.vue?vue&type=script&lang=js&"
export * from "./ExamCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5310866')) {
      api.createRecord('a5310866', component.options)
    } else {
      api.reload('a5310866', component.options)
    }
    module.hot.accept("./ExamCheckBox.vue?vue&type=template&id=a5310866&", function () {
      api.rerender('a5310866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/ExamCheckBox.vue"
export default component.exports